import { openErrorNotification } from '../../js/helpers/notifications'
import { validatePassword } from '../../js/helpers/validations'

export default () => {
  const $ = jQuery

  const forgetPasswordForm = document.querySelector('form#forget-password')

  if (forgetPasswordForm) {
    const firstPassword = forgetPasswordForm.querySelector(
      'input#user-password-first'
    )
    const secondPassword = forgetPasswordForm.querySelector(
      'input#user-password-second'
    )

    const loader = forgetPasswordForm.querySelector(
      '.js-forget-password__loader'
    )
    const submitBtn = forgetPasswordForm.querySelector('.btn')

    forgetPasswordForm.addEventListener('submit', (e) => {
      e.preventDefault()

      if (firstPassword.value !== secondPassword.value) {
        secondPassword.parentNode.querySelector('.form-error').textContent =
          'The passwords must match'
        secondPassword.parentNode.querySelector('.form-error').style.display =
          'block'
      } else {
        secondPassword.parentNode.querySelector('.form-error').style.display =
          'none'
      }

      if (
        validatePassword(
          'form#forget-password input#user-password-first',
          true
        ) &&
        validatePassword(
          'form#forget-password input#user-password-second',
          true
        ) &&
        firstPassword.value === secondPassword.value
      ) {
        $.ajax({
          url: '/wp-admin/admin-ajax.php',
          type: 'POST',
          data: {
            action: 'resetPassword',
            data: $(forgetPasswordForm).serializeArray(),
          },
          beforeSend: function () {
            submitBtn.style.display = 'none'
            loader.style.display = 'block'
          },
          success: function (response) {
            if (response.data.status === 'success') {
              window.location.replace('profile')
            }
          },
          error: function (err) {
            loader.style.display = 'none'
            submitBtn.style.display = 'block'
            openErrorNotification()
            console.log(err)
          },
        })
      }
    })
  }
}
